import { Card } from "react-bootstrap";
import styled from "styled-components";

const StyledSubtitle = styled.div`
    font-size: 15px;
    line-height: 150%;
    text-align: center;
    color: #1e1e1e;
    margin-top: 25px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
`;

const StyledIconInfo = styled.div`
    margin-right: 15px;
    margin-left: 15px;
    & svg {
        vertical-align: middle;
        fill: #8a0538;
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
    & span {
        vertical-align: middle;
    }
`;

const StyledCardWhite = styled(Card)`
    background: #ffffff;
    border: 1px solid #f0f2f2;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    padding: 10px;
`;

const StyledTableExpand = styled.div`
    .table {
        thead {
            font-size: 17px;
            text-align: center;
            vertical-align: middle;
            justify-content: center;
            align-items: center;
            padding: 8px 16px;
            gap: 8px;
            left: 108px;
            top: 337px;
            background: #e4e4e4;
        }
        tbody {
            vertical-align: middle;
            font-weight: 400;
            font-size: 17px;
            line-height: 150%;
            .row-expand-slide-enter-done {
                margin: -8px;
                background: #fff;
            }
        }
    }
`;

const StyledExpandContainer = styled.div`
    padding: 25px;
`;

const StyledExpandLabel = styled.div`
    font-weight: 400;
    font-size: 12px;
    display: flex;
    align-items: center;
    color: #787878;
    width: 100%;
`;

const StyledExpandTextInfo = styled.div`
    font-weight: 400;
    font-size: 17px;
    display: flex;
    align-items: center;
    color: #404040;
    width: 100%;
`;

export {
    StyledSubtitle,
    StyledIconInfo,
    StyledCardWhite,
    StyledTableExpand,
    StyledExpandContainer,
    StyledExpandLabel,
    StyledExpandTextInfo,
};
